import React, { InputHTMLAttributes, forwardRef } from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    className?: string; // Allow overriding/extending classes
    error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, error, ...props }, ref) => {
    return (
        <input
            ref={ref}
            className={`${styles.input} ${error ? styles.error : ''} ${className || ''}`}
            {...props}
        />
    );
});

Input.displayName = 'Input';

export default Input;
